'use client'
import { useTranslation } from '../../context/ConfigContext'
import { CmsSellerFilters, CustomCmsSeller } from '../../../domain/seller'
import Icon from '../Icon/Icon'
import { Icons } from '../Icon/constants'

import { calculateDistance } from './helper'
import { SellerItemOpeningHours } from './SellerItemOpeningHours'

type SellerItem = {
  seller: CustomCmsSeller
  filters?: CmsSellerFilters
}

export const SellerItem = ({ filters, seller }: SellerItem) => {
  const t = useTranslation()

  const distance = filters ? calculateDistance(seller, filters) : null

  return (
    <li className='map-list-sellers-bytype-item'>
      <div className='map-list-sellers-bytype-item-informations'>
        <h4 className='map-list-sellers-bytype-item-title'>
          <a href={seller.url} rel='noreferrer' target='_blank'>
            {seller.name}
          </a>
        </h4>
        <h3 className='map-list-sellers-bytype-item-categories'>{seller.categories.join(' - ')}</h3>
        <div className='map-list-sellers-bytype-item-address'>
          <p>{seller.street}</p>
          <p>
            {seller.postCode} {seller.city}
          </p>
          <p>{seller.country}</p>

          {seller.phone && (
            <p className='map-list-sellers-bytype-item-address-phone'>
              <Icon
                iconName={Icons.PHONE}
                className='map-list-sellers-bytype-item-address-phone-icon'
              />
              <span>{seller.phone}</span>
            </p>
          )}

          {distance && (
            <p>
              {t('Distance', {}, true)}: {distance} {t('km', {}, true)}
            </p>
          )}
        </div>
      </div>
      <SellerItemOpeningHours seller={seller} />
    </li>
  )
}
